import api from './api.js';

class FormBuilderConfigService {
    getConfiguration() {
        return api.get('Reports/FormBuilder/Configuration');
    }
}

export default new FormBuilderConfigService();
